<!--Footer Starts-->
<footer>
    <div class="container-fluid">
        <p class="copyright text-center">
                Copyright  &copy;  {{currentDate | date: 'yyyy'}} <a id="Avanza Consultiria" href="https://avanzaconsultoria.com">AVANZA CONSULTORIA</a>, All rights reserved.          
        </p>
        
    </div>
</footer>
<!--Footer Ends-->